import React from 'react'
import { connect } from 'react-redux';
import { Badge } from 'react-bootstrap'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import UpdateButton from './UpdateButton';
import DeleteButton from './DeleteButton';

 const PeriodsList = ({
  records
}) => {

  /** Here are all the columns */
  const columns = [
    {
      dataField: 'nombre',
      text: 'Nombre'
    },
    {
      dataField: 'inicio_periodo',
      text: 'Fecha de inicio',
      formatter: (cell) => !!cell ? global.moment(cell).format('yyyy-MMM-DD').toUpperCase() : 'N/A'
    },
    {
      dataField: 'fin_periodo',
      text: 'Fecha de finalización',
      formatter: (cell) => !!cell ? global.moment(cell).format('yyyy-MMM-DD').toUpperCase() : 'N/A'
    },
    {
      dataField: 'activo',
      text: 'Estatus',
      formatter: cell => <Badge variant={cell ? 'success' : 'secondary'}>{ cell ? 'Cursando' : 'Inactivo'}</Badge>,
    },
    {
      dataField: 'abierto_para_inscripciones',
      text: 'Inscripciones',
      formatter: cell => <Badge variant={cell ? 'success' : 'secondary'}>{ cell ? 'Abiertas' : 'Cerradas'}</Badge>,
    },
    {
      dataField: 'action',
      text: 'Acciones',
    }
];


  /** serialize dataset */
  const dataset = records.map( ({
    slug,
    label,
    ...rest
  }) => {
    return {
      nombre: label,
      ...rest,
      action: (
        <>
          <UpdateButton slug={slug} />
          <DeleteButton slug={slug} nombre={label} />
        </>
      )
    }
  })



  return (
    <BootstrapTable 
      bootstrap4 keyField='id'
      data={ dataset }
      columns={ columns }
    /> 
  )

}

export default PeriodsList;

